import { render, staticRenderFns } from "./NewProcess.vue?vue&type=template&id=876342f4&scoped=true&"
import script from "./newProcess.ts?vue&type=script&lang=ts&"
export * from "./newProcess.ts?vue&type=script&lang=ts&"
import style0 from "./NewProcess.vue?vue&type=style&index=0&id=876342f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876342f4",
  null
  
)

export default component.exports